import { html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

import styles from "./spinner.css";

@customElement("bp-spinner")
export class Spinner extends LitElement {
  static styles = styles;

  @property({ type: Boolean })
  invert = false;

  @property()
  size: "lg" | "md" | "sm" | "xs" = "md";

  render() {
    return html`
      <div
        class="spinner"
        data-size="${this.size}"
        ?data-invert=${Boolean(this.invert)}
        role="status"
      >
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bp-spinner": Spinner;
  }
}
